import Empty from './Empty.vue';
import CommonSearch from '@/components/CommonSearch.vue';
import IncludeBannerCard from './IncludeBannerCard.vue';
import EmptyCover from './EmptyCover.vue';
import CommonTab from './CommonTab.vue';
import CLoadingBox from './CLoadingBox.vue';
import SvgIcons from './SvgIcons.vue';
import ValueUnitTips from './ValueUnitTips.vue';
import CTeleport from './CTeleport.vue';
import CTooltip from './CTooltip.vue';

import CMobileTabs from './mobile/CMobileTabs.vue';
import CMobileSimpleScroll from './mobile/c-mobile-simple-scroll.vue';
import CMobileScroll from './mobile/CMobileScroll.vue';
import CMobileTable from './mobile/CMobileTable.vue';
import MInlineDropdown from './mobile/MInlineDropdown.vue';

import MixColorMask from './mixColorMask.vue';

const components = {
	Empty,
	CommonSearch,
	IncludeBannerCard,
	EmptyCover,
	CommonTab,
	CLoadingBox,
	SvgIcons,
	ValueUnitTips,
	CTeleport,
	CTooltip,
	CMobileTabs,
	CMobileSimpleScroll,
	CMobileScroll,
	CMobileTable,
	MInlineDropdown,

	MixColorMask
};

export default {
	install(Vue) {
		Object.keys(components).forEach(it => {
			Vue.component(it, components[it]);
		});
	}
};
